import {request} from '@/helpers/apiClient'
import {TIER_CONFIG} from '@/utils/constants/apiConfig/tierConfig'

export const TIER_QUERY_KEY = {
  ACTIVE_TIERS: 'active-tiers',
}
export const getTierStores = async (tierID, queryParams) => request(TIER_CONFIG.TIER_STORES(tierID, queryParams))
export const fetchTiers = async queryParams => request(TIER_CONFIG.TIERS, {}, queryParams)
